import { NavigateMenu, INavigateMenu, DrawerState } from "@gisce/oficina-virtual-components";
import DrawerItems from "./Drawer";
import MainItems from "./Header/MainItems/index";
import ExtraItems from "./Header/ExtraItems/index";
import { useAppSelector } from "@/hooks";
import { FC } from "react";
import { useSettingsContext } from "../Settings/hooks/useSettingsContext";


const NavigationMenu: FC = () => {
  const Settings = useSettingsContext();
  const { 
    isAuthenticating, 
    isAuthenticated,
    loginType 
  } = useAppSelector(store => store.auth);
  
  const NavigateMenuProps: INavigateMenu = {
    orientation: Settings?.header?.variant ?? "vertical",
    headerProps: {
      mainItems: {
        ...(!(isAuthenticating && loginType == "refresh") && {
          upLg: <>
            {isAuthenticated && <MainItems.private.UpLg />}
            {!isAuthenticated && <MainItems.public.UpLg />}
            <MainItems.unprotected.UpLg />
          </>,
          upSm: <>
            {isAuthenticated && <MainItems.private.UpSm />}
            {!isAuthenticated && <MainItems.public.UpSm />}
            <MainItems.unprotected.UpSm />
          </>,
          upXs: <>
            {isAuthenticated && <MainItems.private.UpXs />}
            {!isAuthenticated && <MainItems.public.UpXs />}
            <MainItems.unprotected.UpXs />
            </>
        })
      },
      extraItems: {
        upLg: <>
          {isAuthenticated && <ExtraItems.private.UpLg />}
          {!isAuthenticated && <ExtraItems.public.UpLg />}
          {<ExtraItems.unprotected.UpLg />}
        </>,
        upSm: <>
          {isAuthenticated && <ExtraItems.private.UpSm />}
          {!isAuthenticated && <ExtraItems.public.UpSm />}
          <ExtraItems.unprotected.UpSm />
        </>,
        upXs: <>
          {isAuthenticated && <ExtraItems.private.UpXs />}
          {!isAuthenticated && <ExtraItems.public.UpXs />}
          <ExtraItems.unprotected.UpXs />
        </>
      }
    },
    drawerProps: {
      headerChildren: <>
        {isAuthenticated && <DrawerItems.private.HeaderDrawerItems />}
        {!isAuthenticated && <DrawerItems.public.HeaderDrawerItems />}
        <DrawerItems.unprotected.HeaderDrawerItems />
      </>,
      items: <>
        <DrawerItems.unprotected.MainDrawerItems />
        {isAuthenticated && <DrawerItems.private.MainDrawerItems />}
        {!isAuthenticated && <DrawerItems.public.MainDrawerItems />}
      </>,
      bottomItems: <>
        {isAuthenticated && <DrawerItems.private.BottomDrawerItems />}
        {!isAuthenticated && <DrawerItems.public.BottomDrawerItems />}
        <DrawerItems.unprotected.BottomDrawerItems />
      </>
    }
  };

  return (
    // <header role="banner">
    <>
      <DrawerState>
        <NavigateMenu {...NavigateMenuProps} />
      </DrawerState>
    </>
    // </header>
  );
};

export default NavigationMenu;